import { render, staticRenderFns } from "./ManageOption.vue?vue&type=template&id=8c273d4c&scoped=true&"
import script from "./ManageOption.vue?vue&type=script&lang=js&"
export * from "./ManageOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c273d4c",
  null
  
)

export default component.exports